/**
 * Created by WorkAxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Admin: shyam@workaxis.in
 * Date: 3/31/2022
 * Time: 12:52 PM
 * Project: w_crm
 */
import React, {useRef} from "react";
import "./style.css";
import {Tooltip as ReactTooltip} from 'react-tooltip'
import {getUUID} from "../../utils/util";

export default function Tooltip({className, title = null, toolTip = null, children, ...props}) {
    // Unique id per instance — shared "my-tooltip" caused duplicate tooltips when many mounted
    // (React <18 has no useId; keep a stable id for the component lifetime)
    const tooltipId = useRef(`tooltip-${getUUID()}`).current;

    // Nothing to show: skip react-tooltip mount entirely
    if (!toolTip && !title) {
        return <>{children}</>;
    }

    const content = title ? `${title}${toolTip ? ` — ${toolTip}` : ""}` : toolTip;

    return (
        <>
            <ReactTooltip
                id={tooltipId}
                {...props}
                place={"top"}
                positionStrategy={"fixed"}
                style={{maxWidth: 300, zIndex: 100}}
            />
            <div data-tooltip-id={tooltipId} data-tooltip-content={content} className={className}>
                {children}
            </div>
        </>
    );
}
